// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZBtT","left":"styles_left__2TqN8","right":"styles_right__1xf3R","alert":"styles_alert__1g8yx"};